import {
  ConnectedPosition,
  HorizontalConnectionPos,
  VerticalConnectionPos,
} from '@angular/cdk/overlay';

export type MenuPositionValue = 'top' | 'right' | 'bottom' | 'left';
export type MenuPosition = [MenuPositionValue, MenuPositionValue];

interface ConvertedPosition extends ConnectedPosition {
  originFallbackX: HorizontalConnectionPos;
  originFallbackY: VerticalConnectionPos;
  overlayFallbackX: HorizontalConnectionPos;
  overlayFallbackY: VerticalConnectionPos;
}

function convertSideMenuPosition(side: MenuPositionValue): ConvertedPosition {
  if (side === 'top' || side === 'bottom') {
    return {
      originX: 'start',
      originY: side,
      overlayX: 'start',
      overlayY: side === 'top' ? 'bottom' : 'top',
      originFallbackX: 'end',
      originFallbackY: side === 'top' ? 'bottom' : 'top',
      overlayFallbackX: 'end',
      overlayFallbackY: side,
    };
  } else {
    return {
      originX: side === 'left' ? 'start' : 'end',
      originY: 'top',
      overlayX: side === 'left' ? 'end' : 'start',
      overlayY: 'top',
      originFallbackX: side === 'left' ? 'end' : 'start',
      originFallbackY: 'bottom',
      overlayFallbackX: side === 'left' ? 'start' : 'end',
      overlayFallbackY: 'bottom',
    };
  }
}

export function convertMenuPositionToConnectedPositions(
  [side, align]: MenuPosition,
  offsetY = 0,
): ConnectedPosition[] {
  let {
    originX,
    originY,
    overlayX,
    overlayY,
    originFallbackX,
    originFallbackY,
    overlayFallbackX,
    overlayFallbackY,
  } = convertSideMenuPosition(side);

  if (align === 'top' || align === 'bottom') {
    originY = align;
    overlayY = originY;
  } else {
    originX = align === 'left' ? 'start' : 'end';
    overlayX = originX;
  }

  return [
    { originX, originY, overlayX, overlayY, offsetY },
    {
      originX: originFallbackX,
      originY,
      overlayX: overlayFallbackX,
      overlayY,
      offsetY,
    },
    {
      originX,
      originY: originFallbackY,
      overlayX,
      overlayY: overlayFallbackY,
      offsetY: -offsetY,
    },
    {
      originX: originFallbackX,
      originY: originFallbackY,
      overlayX: overlayFallbackX,
      overlayY: overlayFallbackY,
      offsetY: -offsetY,
    },
  ];
}
